export default "__VITE_ASSET__wfF_4qHC__"